import axios from "axios"
import { apiWrapper } from "../configs"
import apiClient from "../helpers/apiClient"

const apiCallerCustomer = axios.create({
	baseURL: apiWrapper,
	headers: {
		"x-issuer": "PORTAL",
	},
})

apiCallerCustomer.interceptors.response.use((res) => {
	res.data.payload = res.data.data
	return res
})
class Customer {
	async createAccount(payload, config) {
		const {
			mobileNo,
			email,
			password,
			confirmPassword,
			registerType,
			firstName,
			lastName,
			dob,
			nationality,
			salutation,
			subscription,
			cardNo,
			securityCode,
			device,
		} = payload
		const formatDob = dob.split("/")
		const res = await apiClient.post(
			"api/account/SignUp",
			{
				mobileNo: mobileNo,
				email: email,
				password: password,
				confirmPassword: confirmPassword,
				registerType: 0,
				firstName: firstName,
				lastName: lastName,
				dob: `${formatDob[2]}-${formatDob[1]}-${formatDob[0]}`,
				nationality: nationality || "VN",
				salutation: salutation,
				subscription: { email: true },
				cardLists: [{ cardNo: cardNo, passcode: securityCode }] || [
					{ cardNo: "", passcode: "" },
				],
				gender: "",
				device,
			},
			config
		)

		res.data.payload = res.data.data // mapping data to payload for redux

		return res
	}

	async verifyEmailVoucherBundle(payload, config) {
		const { RedemptionPin, EmailRedemption } = payload
		const res = await apiCallerCustomer.post(
			"ms-customer/api/voucherbundle/PreRedeem",
			{
				RedemptionPin,
				EmailRedemption,
			},
			config
		)
		return res
	}
}
export const customerService = new Customer()



// WEBPACK FOOTER //
// ./src/service/customer.js